import { createContext, useContext, useState, ReactNode } from "react";

interface SelectedCameraContextType {
  selectedDeviceId: string | null;
  setSelectedDeviceId: (deviceId: string | null) => void;
}

const SelectedCameraContext = createContext<SelectedCameraContextType | undefined>(undefined);

export const useSelectedCamera = () => {
  const context = useContext(SelectedCameraContext);
  if (!context) {
    throw new Error("useSelectedCamera must be used within a SelectedCameraProvider");
  }
  return context;
};

interface SelectedCameraProviderProps {
  children: ReactNode;
}

export const SelectedCameraProvider = ({ children }: SelectedCameraProviderProps) => {
  const [selectedDeviceId, setSelectedDeviceId] = useState<string | null>(null);

  return (
    <SelectedCameraContext.Provider value={{ selectedDeviceId, setSelectedDeviceId }}>
      {children}
    </SelectedCameraContext.Provider>
  );
};